import { ArrowRight, ChevronDown, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";

export const homeFAQs = [
  {
    question: "Where is Computer Zone located, and what are your hours?",
    answer: "Computer Zone is at 3079 Roswell Rd, Marietta, GA 30062, serving Marietta and East Cobb. Our hours are Monday–Friday, 9 AM–5 PM, and Saturday–Sunday, 12–3 PM, Eastern Time. Call (678) 236-0376 to speak with our team.",
  },
  {
    question: "Do you offer a free computer diagnostic?",
    answer: "Yes. Computer Zone offers a free 15-minute diagnostic at our Marietta shop. Bring your device in for an initial assessment and a discussion of next steps, with no commitment or pressure to proceed with a repair.",
  },
  {
    question: "Do you repair both Windows PCs and Apple Macs?",
    answer: "Yes. Computer Zone repairs Windows PCs, Apple Macs, laptops, and desktop computers. Services include hardware troubleshooting, screen and battery replacement, storage and memory upgrades, and software support.",
  },
  {
    question: "Can you remove viruses, malware, and unwanted pop-ups?",
    answer: "Yes. Computer Zone provides virus, malware, spyware, and adware removal, along with browser hijacker cleanup and antivirus configuration. For ransomware, we assess the device and recovery options; file recovery or decryption is not guaranteed.",
  },
  {
    question: "Can you recover files from a failed hard drive or SSD?",
    answer: "Computer Zone assesses data recovery options for failed hard drives, SSDs, USB drives, and memory cards, including deleted files and corrupted storage. Whether files can be recovered depends on the device's condition and the type of data loss; recovery is not guaranteed.",
  },
  {
    question: "Do you offer remote support and on-site business IT support?",
    answer: "Yes. Computer Zone offers remote support for software issues, updates, email and printer setup, and troubleshooting. We also provide on-site technical support and network setup for homes and small businesses in the Marietta and East Cobb area. Hardware repairs may require an in-store visit.",
  },
  {
    question: "How do I schedule a computer repair in Marietta?",
    answer: "Use the appointment scheduler on this website to choose an available date and time, or call Computer Zone at (678) 236-0376. In-store appointments take place at 3079 Roswell Rd, Marietta, GA 30062. Virtual appointments are also available for remote support.",
  },
];

export default function FAQSection() {
  return (
    <section id="faq" aria-labelledby="faq-heading" className="bg-background py-20 scroll-mt-24">
      <div className="container">
        <div className="grid gap-8 lg:grid-cols-[1fr_2fr] lg:gap-16">
          <div>
            <p className="text-primary-strong font-semibold text-sm uppercase tracking-widest mb-3">Common questions</p>
            <h2 id="faq-heading" className="font-display text-3xl md:text-4xl font-extrabold text-primary dark:text-foreground">Computer repair FAQs</h2>
            <p className="text-muted-foreground mt-4 leading-relaxed">Answers from Computer Zone in Marietta / East Cobb.</p>
            <Button asChild variant="link" className="mt-4 px-0 h-auto whitespace-normal text-left">
              <a href="tel:+16782360376"><Phone className="shrink-0" /> (678) 236-0376</a>
            </Button>
          </div>
          <div className="min-w-0 border-t">
            {homeFAQs.map((faq, index) => (
              <details key={faq.question} open={index === 0 ? true : undefined} className="group border-b">
                <summary className="flex cursor-pointer list-none items-start justify-between gap-4 py-5 text-left font-semibold text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring [&::-webkit-details-marker]:hidden">
                  <h3 className="text-base leading-relaxed">{faq.question}</h3>
                  <ChevronDown aria-hidden="true" className="h-5 w-5 shrink-0 mt-1 text-primary transition-transform group-open:rotate-180 motion-reduce:transition-none" />
                </summary>
                <p className="pb-6 pr-4 text-muted-foreground leading-relaxed">{faq.answer}</p>
              </details>
            ))}
            <Button asChild className="mt-6 max-w-full whitespace-normal h-auto py-3">
              <a href="#booking">Schedule a free diagnostic <ArrowRight className="shrink-0" /></a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}